module["exports"] = [
  "##-###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/postcode.js
// module id = 972
// module chunks = 0